<template>
  <a-modal
    :visible="joinCar"
    @cancel="joinCarClose"
    @ok="joinCarFn"
    width="900px"
    :zIndex="1010"
    :title="$t('generic.addToCart')"
    :getContainer="() => document.getElementById('app')"
    wrapClassName="imgModal"
  >
    <div class="car-wrap clearFix">
      <div class="right-wrap">
        <div class="row-list">
          <a-row type="flex">
            <a-col :span="3">
              <span class="tit-span">{{ $t('generic.color') }}:</span>
            </a-col>
            <a-col :span="21">
              <span
                class="color-span"
                :class="{ on: colorIndex === i }"
                v-for="(item, i) in colorsList"
                :key="i"
                @click="colorIndexFn(i)"
              >
                <a class="color-a" :style="{ background: colorsData[item] }"></a>
              </span>
            </a-col>
          </a-row>
        </div>
        <template v-for="(item, i) in carData">
          <div class="row-list" :key="i" v-if="+colorsList[colorIndex] === +item.color_id">
            <a-row type="flex">
              <a-col :span="8">
                <span class="size-span">{{ item.size_name }}</span>
              </a-col>
              <a-col :span="6">
                <span class="price-wrap">
                  <span
                    style="display: inline-block;margin-right: 2px;border-radius: 4px;font-size: 12px;line-height: 1;color: #fff;padding: 2px 6px;background: #fe9236;vertical-align: middle;"
                    v-if="item.is_promotion === 1"
                    >{{ $t('design.promotion') }}</span
                  >
                  $
                  <b>{{ item.price }}</b>
                </span>
              </a-col>
              <a-col :span="6">
                <span class="input-wrap">
                  <a-input-number
                    allowClear
                    style="width: 140px"
                    :min="0"
                    :max="99999"
                    v-model="item.num"
                    @blur="onBlur(item)"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
        </template>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { getColorsInSysterm } from '@/api/mergeSKU/index'
import { batchAddCart, getShowPrice } from '@/api/cart'
export default {
  name: 'JoinCar',
  data() {
    return {
      product_id: '',
      carData: [],
      colorsList: [],
      colorsData: [],
      inputNumber: 0,
      sizeIndex: 0,
      colorIndex: 0,
      joinCar: false,
      detail: {}
    }
  },
  components: {},
  props: [],
  created() {
    getColorsInSysterm().then(res => {
      res.data.forEach(item => {
        this.colorsData[item.id] = `#${item.tone1}`
      })
    })
  },
  methods: {
    ...mapActions(['getCartData']),
    colorIndexFn(i) {
      console.log(this.colorsList, this.carData)
      if (this.colorIndex !== i) {
        this.colorIndex = i
      }
    },
    getShowPriceFn(n, item) {
      let obj = {}
      if (n === 1) {
        obj = {
          product_id: this.detail.id,
          is_all: 1
        }
      } else {
        // const arr = this.carData.filter(item => {
        //   return +item.num > 0
        // })
        // if (!arr.length) {
        //   return
        // }
        obj = {
          product_id: this.detail.id,
          color_id: item.color_id,
          size_id: item.size_id,
          num: item.num
          // data: arr.map(item => {
          //   return {
          //     color_id: item.color_id,
          //     size_id: item.size_id,
          //     num: item.num
          //   }
          // })
        }
      }
      getShowPrice(obj).then(res => {
        const obj = res.data[0].product_child.length ? res.data[0].product_child : {}
        if (n === 1) {
          this.carData = res.data[0].product_child
          this.carData.forEach(item => {
            if (
              +this.detail.id === +item.product_id &&
              +this.detail.default_color_id === +item.color_id &&
              +this.detail.default_size_id === +item.size_id
            ) {
              item.num = 1
            }
          })
        } else {
          this.carData.forEach(item => {
            if (+item.color_id === +obj.color_id && +item.size_id === +obj.size_id) {
              item.num = obj.num
              item.price = obj.price
            }
          })
        }
      })
    },
    joinCarFn() {
      let n = 0
      const arr = this.carData.map(item => {
        if (+item.num > 0) {
          n++
        }
        return {
          product_id: item.product_id,
          num: item.num,
          color_id: item.color_id,
          size_id: item.size_id
        }
      })
      if (n === 0) {
        this.$message.error(this.$t('design.addCartRule'), 2)
        return
      }
      batchAddCart({ data: arr }).then(res => {
        this.joinCar = false
        this.getCartData()
        this.InitialFn()
        this.$emit('ok')
        // this.$router.push('/cart')
        // this.$message.success({
        //   content: (
        //     <span>
        //       {this.$t('design.addCartSuccess')}
        //       <a-button type="link" onClick={() => window.open('/cart')}>
        //         {this.$t('design.addCartSuccess')}
        //       </a-button>
        //     </span>
        //   ),
        //   duration: 4
        // })
      })
    },
    joinCarClose() {
      this.joinCar = false
    },
    onBlur(item) {
      this.getShowPriceFn(0, item)
    },
    InitialFn() {
      this.colorIndex = 0
      this.inputNumber = 0
      this.carData = []
      this.colorsList.forEach((item, i) => {
        if (+item === +this.detail.default_color_id) {
          this.colorIndex = i
        }
      })
      this.getShowPriceFn(1)
    }
  },
  mounted() {},
  watch: {
    joinCar(value) {
      if (value) {
        this.InitialFn()
      }
    }
  },
  computed: {}
}
</script>

<style scoped lang="less">
.car-wrap {
  padding: 20px;
  .img-wrap {
    overflow: hidden;
    float: left;
    width: 220px;
    height: 200px;
    border: 1px solid #ccc;
    img {
      max-width: 100%;
    }
  }
  .right-wrap {
    overflow: hidden;
    padding-left: 20px;
    font-size: 0;
    .row-list {
      margin-bottom: 12px;
    }
    .tit-span {
      font-size: 14px;
      color: #333;
      line-height: 32px;
    }
    .price-wrap {
      font-size: 18px;
      line-height: 32px;
      color: #4b9bdf;
      span {
        font-size: 14px;
        color: #ff0000;
        vertical-align: top;
      }
      b {
        font-size: 24px;
      }
    }
    .color-span {
      display: inline-block;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 6px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      a {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 5px;
      }
      &.on {
        -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
      }
    }
    .size-span {
      display: inline-block;
      margin-right: 6px;
      margin-bottom: 6px;
      padding: 0 12px;
      height: 32px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      font-size: 12px;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      &.on {
        border: 1px solid #4b9bdf;
      }
    }
  }
}
.uploadWrap {
  height: 330px;
  width: 294px;
  margin-right: 16px;
  float: left;
  margin-bottom: 16px;
  padding: 32px 16px;
  .upload {
    width: 100%;
    height: 100%;
    border: 2px dashed #cccccc;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    border-radius: 5px;
    &:hover {
      border: 2px dashed #4b9bdf;
      color: #4b9bdf;
    }
  }
}
.imageItemBlock {
  margin: 0 -10px;
}
.imageItem {
  position: relative;
  height: 330px;
  width: 288px;
  border-radius: 5px;
  margin-right: 10px;
  margin-left: 10px;
  padding: 16px;
  margin-top: 20px;
  box-shadow: 3px 3px 20px rgba(24, 62, 130, 0.11);
  transition: all 0.3s;
  float: left;
  .carIcon {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    color: #4b9bdf;
    z-index: 99;
    display: flex;
    align-items: center;
    img {
      height: 24px;
      margin-right: 10px;
    }
  }
  .angle-wrap {
    position: absolute;
    top: -3px;
    left: 0;
    z-index: 9;
    .buyer {
      position: relative;
      display: inline-block;
      b {
        position: absolute;
        left: 6px;
        top: 8px;
        font-size: 16px;
        color: #fff;
        line-height: 1;
      }
    }
  }

  .imgWrap {
    height: 256px;
    width: 256px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    img {
      transition: all 0.3s ease-in-out;
    }
    .imgInfo {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0);
      transition: all 0.3s;
      padding-top: 30px;
      p {
        margin-bottom: 5px;
        color: white;
        opacity: 0;
        padding-left: 25px;
        transition: all 0.3s ease-in-out;
        transform: translateY(100px);
        transition-delay: 0.1s;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p:nth-child(1) {
        transition-delay: 0s;
        height: 50px;
        color: white;
        background: rgb(71, 150, 229);
        line-height: 40px;
        font-size: 20px;
        margin-bottom: 10px;
        transform: translateY(100px);
      }
    }
    .pushpin {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 18px;
      color: #1890ff;
    }
    .pushpinHidden {
      visibility: hidden;
      color: black;
    }
  }
  .imgControlBar {
    margin-top: 9px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    .xs-box {
      display: flex;
      .tips {
        margin-left: 3px;
        border-radius: 50%;
        display: block;
        height: 6px;
        width: 6px;
      }
    }

    .name {
      display: inline-block;
      width: 160px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      vertical-align: middle;
      font-size: 16px;
    }
  }
  .check {
    visibility: hidden;
  }
  &:hover {
    box-shadow: 3px 3px 20px rgba(24, 62, 130, 0.5);
    .check,
    .pushpin {
      visibility: visible;
    }
    .imgWrap > .imgWidth {
      transform: scale(1.25);
    }
    .imgWrap > .imgHeight {
      transform: scale(1.25);
    }
    .imgInfo {
      background: rgba(0, 0, 0, 0.3);
      p {
        opacity: 1;
        transform: translateY(0px);
      }
      p:nth-child(1) {
        transform: translateY(0px);
      }
    }
  }
}
.modalBottom {
  padding: 18px 18px 0 18px;
  display: flex;
  justify-content: space-between;
}
.modal-img-wrap {
  position: relative;
  padding: 40px 20px 40px 20px;
  &.leftWrap {
    padding: 40px 20px 40px 140px;
  }
  .swich-wrap {
    overflow: hidden;
    position: absolute;
    width: 82px;
    top: 40px;
    left: 20px;
    bottom: 40px;
    cursor: pointer;
    .anticon {
      position: absolute;
      margin-left: -13px;
      font-size: 26px;
      color: #007aff;
    }
    .anticon-up {
      left: 50%;
      top: 0;
    }
    .anticon-down {
      left: 50%;
      bottom: 0;
    }
  }
  .swich-hd {
    overflow: auto;
    position: absolute;
    top: 26px;
    left: 0;
    bottom: 26px;
    width: 110px;
    background: #fff;
    .auto-item {
      position: relative;
      height: 82px;
      width: 82px;
      border: 1px solid #d9d7d3;
      border-radius: 3px;
      margin-bottom: 10px;
      .reDesign {
        position: absolute;
        height: 16px;
        width: 16px;
        top: 0;
        right: 0;
      }
      .set-span {
        position: absolute;
        left: 0;
        top: 0;
        color: #fff;
        font-size: 12px;
        background: #3699ff;
      }
      .delete-span {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0 2px;
        color: #fff;
        font-size: 12px;
        background: #3699ff;
      }
      .xs-box-pos {
        position: absolute;
        bottom: 4px;
        left: 0;
        z-index: 9;
      }
      .xs-box {
        display: flex;
        width: 65px;
        .tips {
          margin-left: 3px;
          border-radius: 50%;
          display: block;
          height: 6px;
          width: 6px;
        }
      }
      &:hover {
        border: 1px solid #007aff;
      }
      img {
        width: 100%;
      }
      &.on {
        border: 1px solid #007aff;
      }
    }
  }
  .img-swip {
    position: relative;
    margin-top: 80px;
    height: 420px;
    text-align: center;
    .swip-info-wrap {
      position: absolute;
      top: -88px;
      left: 0;
      width: 100%;
      padding: 20px;
      z-index: 999;
      p {
        margin: 0;
        line-height: 24px;
        font-size: 14px;
        color: #666;
      }
    }
    img {
      max-width: 100%;
    }
    .swiper-group {
      position: absolute;
      max-width: 160px;
      left: 0;
      bottom: -24px;
      z-index: 999;
      span {
        float: left;
        margin-bottom: 2px;
        // border: 1px solid #b9adad;
        border-radius: 3px;
        width: 24px;
        height: 16px;
        margin-left: 2px;
        cursor: pointer;
      }
      .on {
        border: 2px solid #1890ff;
        // color: #007aff;
      }
    }
  }
}
.cp-table-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  .img-box {
    position: relative;
    margin: 0 12px;
    min-height: 120px;
    padding: 4px;
    border: 1px solid #ddd;
    cursor: pointer;
    .angle-wrap {
      position: absolute;
      top: -3px;
      left: 0;
      z-index: 9;
      .buyer {
        position: relative;
        display: inline-block;
        b {
          position: absolute;
          left: 6px;
          top: 8px;
          font-size: 16px;
          color: #fff;
          line-height: 1;
        }
      }
    }
  }
  .cp-info-box {
    text-align: left;
    min-width: 200px;
    p {
      margin: 4px 0;
      word-break: break-all;
    }
  }
}
.specWrap {
  p {
    margin: 4px 0;
  }
}
.operationWrap {
  a {
    color: #3699ff;
    img {
      margin-right: 6px;
      vertical-align: middle;
    }
  }
}
.filWrap {
  padding: 0 30px;
  margin-bottom: 10px;
  text-align: right;
}
</style>
